
























































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppliedLessonType } from '@/enums/AppliedLessonType';
import { validate } from '@/helpers/validation/validate';
import { hideModal } from '@/helpers/modal';
import type { Worksheet } from '@/models/worksheet';
import { Getter } from 'vuex-class';
import type { Project } from '@/models/project';
import { showErrorNotification } from '@/helpers/showErrorNotification';
import { ValidationResult } from '@/helpers/validation/Validator';
import FormError from '@/components/utils/FormError.vue';
import { pmAppliedLessonWebservice } from '@/webservices/pmappliedlesson';
import { appliedLessonWebservice } from '@/webservices/appliedlesson';
import type { PMAppliedLesson } from '@/models/pmappliedlesson';
import type { AppliedLesson } from '@/models/appliedlesson';
import type { PMLesson } from '@/models/pmlesson';
import { showSuccessNotification } from '@/helpers/showSuccessNotification';
import type { Lesson } from '@/models/lesson';
import type { CompanySetting } from '@/models/companySetting';
import moment from 'moment';
import { getCombinedProjectUsers } from '@/helpers/getCombinedProjectUsers';
import { CombinedUser } from '@/helpers/getCombinedProjectUsers';
import FormTopicPicker from '@/components/form/FormTopicPicker.vue';
import FormSubphasePicker from '@/components/form/FormSubphasePicker.vue';
import FormItem from '@/components/form/FormItem.vue';
import FormProjectUserPicker from '@/components/form/FormProjectUserPicker.vue';
import FormDynamicFieldPicker from '@/components/form/FormDynamicFieldPicker.vue';
import PrineButton from '@/components/prine/PrineButton.vue';
import type { User } from '@/models/user';
import type { Topic } from '@/models/topic';

@Component({
    name: 'WorksheetCreateAppliedLessonModal',
    components: {
        FormDynamicFieldPicker,
        FormProjectUserPicker,
        FormItem,
        FormSubphasePicker,
        FormTopicPicker,
        FormError,
        PrineButton,
    },
})
export default class WorksheetCreateAppliedLessonModal extends Vue {
    get users(): CombinedUser[] {
        return getCombinedProjectUsers(this.selectedProject);
    }
    protected disabled: boolean = false;
    @Prop({
        required: true,
    })
    private type: AppliedLessonType;

    @Prop({
        required: true,
    })
    private worksheet: Worksheet;

    @Prop({
        required: false,
    })
    private saved: (options: {}) => void;

    private AppliedLessonType = AppliedLessonType;
    private hideModal = hideModal;

    private addToKnowledgeBase = false;

    @Getter('account/companySetting') private companySetting: CompanySetting;
    @Getter('utils/currentLocale') private currentLocale: string;
    @Getter('project/selectedProject') private selectedProject: Project;

    private validation: ValidationResult = { success: false, errors: [] };

    private data: {
        insight: string;
        todo: string;
        responsible_user: User | null;
        contacttill: Date | null;
        solution: string;
        topic: {};
        sub_phase: undefined;
        dynamic_field: undefined;
        cost: number | null;
        probability: number | null;
    } = {
        insight: '',
        todo: '',
        responsible_user: null,
        contacttill: null,
        solution: '',
        topic: {},
        sub_phase: undefined,
        dynamic_field: undefined,
        cost: null,
        probability: null,
    };

    hasMsIntegration() {
        return this.selectedProject.ms_integration === 'done' || this.selectedProject.ms_integration === 'pending';
    }

    private loadDefaultTopic(topic: Topic) {
        if (Object.keys(this.data.topic).length === 0) {
            this.data.topic = topic;
        }
    }

    private save() {
        const validations: Record<string, string[]> = {
            insight: ['required', 'string'],
        };

        if (this.type === AppliedLessonType.AppliedLesson) {
            validations.topic = ['required'];
        } else if (this.type === AppliedLessonType.PMAppliedLesson) {
            validations.sub_phase = ['required'];
        }

        this.validation = validate(validations, this.data);

        if (!this.validation.success) {
            return false;
        }

        const webservice =
            this.type === AppliedLessonType.PMAppliedLesson ? pmAppliedLessonWebservice : appliedLessonWebservice;

        this.disabled = true;

        webservice.getByWorksheetId(this.worksheet.id).then((response) => {
            const appliedLessons = response.data.map((appliedLesson) => {
                const responsible_user_id = appliedLesson.responsible_user_id
                    ? appliedLesson.responsible_user_id
                    : appliedLesson.external_responsible_user_id;

                const user = this.users.find((_) => _.user_id === responsible_user_id);

                appliedLesson.responsible_user = user ? user : null;

                return appliedLesson;
            });

            // neutralize time zone
            if (this.data.contacttill) {
                this.data.contacttill = new Date(
                    this.data.contacttill.setMinutes(
                        this.data.contacttill.getMinutes() - this.data.contacttill.getTimezoneOffset()
                    )
                );
            }
            // neutralize time zone
            if (this.data.contacttill) {
                this.data.contacttill = new Date(
                    this.data.contacttill.setMinutes(
                        this.data.contacttill.getMinutes() - this.data.contacttill.getTimezoneOffset()
                    )
                );
            }
            // We have to do quite a bit of workaround here since there is no dedicated "add new single applied lesson" endpoint.
            switch (this.type) {
                case AppliedLessonType.AppliedLesson:
                    const newAppliedLesson = {
                        id: 0,
                        done: false,
                        needscheck: false,
                        checked: false,
                        lesson: {
                            id: 0,
                            insight: this.data.insight,
                            project_only: !this.addToKnowledgeBase,
                            topic: this.data.topic,
                        } as Partial<Lesson>,
                        insight: this.data.insight,
                        todo: this.data.todo,
                        responsible_user: this.data.responsible_user,
                        contacttill: this.data.contacttill ? moment(this.data.contacttill).toDate() : null,
                        solution: this.data.solution,
                        dynamic_field: this.data.dynamic_field,
                        cost: this.data.cost,
                        probability: this.data.probability,
                    } as Partial<AppliedLesson>;

                    appliedLessonWebservice
                        .store(this.worksheet.id, appliedLessons, [newAppliedLesson as AppliedLesson])
                        .then((response2) => {
                            showSuccessNotification('toastMessages.store.lesson');
                            hideModal();
                            if (this.saved) {
                                this.saved({ highlight: response2.data.id });
                            }
                        })
                        .catch(() => {
                            showErrorNotification('toastMessages.error.worksheet');
                            this.disabled = false;
                            this.disabled = false;
                        });
                    break;

                case AppliedLessonType.PMAppliedLesson:
                    const newPMAppliedLesson = {
                        id: 0,
                        done: false,
                        needscheck: false,
                        checked: false,
                        pm_lesson: {
                            id: 0,
                            insight: this.data.insight,
                            project_only: !this.addToKnowledgeBase,
                            sub_phase: this.data.sub_phase,
                        } as Partial<PMLesson>,
                        insight: this.data.insight,
                        todo: this.data.todo,
                        responsible_user: this.data.responsible_user,
                        contacttill: this.data.contacttill ? new Date(this.data.contacttill) : null,
                        solution: this.data.solution,
                        dynamic_field: this.data.dynamic_field,
                    } as Partial<PMAppliedLesson>;

                    pmAppliedLessonWebservice
                        .store(this.worksheet.id, appliedLessons, [newPMAppliedLesson as PMAppliedLesson])
                        .then((response2) => {
                            showSuccessNotification('toastMessages.store.lesson');
                            hideModal();
                            if (this.saved) {
                                this.saved({ highlight: response2.data.id });
                            }
                        })
                        .catch(() => {
                            showErrorNotification('toastMessages.error.worksheet');
                            this.disabled = false;
                            this.disabled = false;
                        });
                    break;
            }
        });
    }
}
